import { FC, useMemo } from 'react';
import CountdownTimer from 'src/components/common/CountdownTimer';
import { IRaffleDrawInfo } from '../../types';
import { RaffleDrawSlider } from './RaffleDrawSlider';
import './styles.scss';

const RaffleDrawInfo: FC<IRaffleDrawInfo> = ({ expireTime, slider }) => {
  const bannerSlider = useMemo(() => {
    if (!slider?.length) return null;

    const items = slider?.[0]?.relation?.slides;

    const images =
      items?.map((b: { image?: { path?: string } }) => b.image?.path).filter((p): p is string => Boolean(p)) || [];
    if (!images.length) return null;

    const buttonActionSlide = items?.find((slide) => slide.buttonAction?.variant !== 'noAction');

    const slideClickActionSlide = items?.find((slide) => slide.slideClickAction?.variant !== 'noAction');

    const haveButtonAction = Boolean(buttonActionSlide);
    const haveSlideClickAction = Boolean(slideClickActionSlide);

    return (
      <RaffleDrawSlider
        images={images}
        haveButtonAction={haveButtonAction}
        haveButtonActionData={buttonActionSlide?.buttonAction}
        haveSlideClickAction={haveSlideClickAction}
        haveSlideClickActionData={slideClickActionSlide?.slideClickAction}
      />
    );
  }, [slider]);

  return (
    <div className="raffle_draw_info_container">
      <div className="raffle_draw_info_slider">{bannerSlider}</div>
      <div className="raffle_draw_info_content">
        <div className="countdown_wrapper">
          <CountdownTimer size="lg" targetDate={expireTime || undefined} longNames view="names" />
        </div>
      </div>
    </div>
  );
};

export default RaffleDrawInfo;
